// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".b-toaster{z-index:2004}.btn-link-date{font-size:.9em;line-height:1.2rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
